import { render, staticRenderFns } from "./Recommendation.vue?vue&type=template&id=15eec902&scoped=true"
import script from "./Recommendation.vue?vue&type=script&lang=js"
export * from "./Recommendation.vue?vue&type=script&lang=js"
import style0 from "./Recommendation.vue?vue&type=style&index=0&id=15eec902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eec902",
  null
  
)

export default component.exports